import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const Product = () => {
  const location = useLocation();
  const state = location.state || {};
  const typeHome = state.typeHome || "";

  const [backendData, setBackendData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterType, setFilterType] = useState(typeHome); // סינון לפי קטגוריה

  useEffect(() => {
    fetchProduct();
  }, [typeHome]);

  const fetchProduct = async () => {
    try {
      const res = await fetch("/product", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ typeHome }),
      });
      const data = await res.json();
      setBackendData(data.dataTable || []);
      setFilteredData(data.dataTable || []);
    } catch (error) {
      console.log("Error fetching product:", error);
    }
  };

  // שינוי הסינון העליון
  const handleFilterChange = (e) => {
    const selected = e.target.value;
    setFilterType(selected);
    const filtered = backendData.filter(item => item.type_house === selected || selected === "");
    setFilteredData(filtered);
  };

  // תרגום טייפים
  const getTypeHomeLabel = (key) => {
    switch (key) {
      case "home_shabat": return "דירה לשבת";
      case "sal": return "דירות למכירה";
      case "kait": return "דירות להשכרה";
      default: return "לא ידוע";
    }
  };

  return (
    <div className="container mt-4" dir="rtl">
      <h2 className="text-center mb-4">מאגר נכסים</h2>

      {/* סינון לפי קטגוריה */}
      {backendData.length > 0 && (
        <div className="row mb-4 justify-content-center">
          <div className="col-md-4">
            <select
              className="form-select text-end"
              value={filterType}
              onChange={handleFilterChange}
            >
              <option value="">הצג הכל</option>
              <option value="home_shabat">דירות לשבת</option>
              <option value="sal">דירות למכירה</option>
              <option value="kait">דירות להשכרה</option>
            </select>
          </div>
        </div>
      )}

      {/* גריד של נכסים */}
      <div className="row">
        {filteredData.length === 0 ? (
          <p className="text-center">לא נמצאו תוצאות</p>
        ) : (
          filteredData
            .filter(item => filterType === "" || item.type_house === filterType)
            .map((item, i) => (
              <div className="col-md-4 mb-4" key={i}>
                <div className="card h-100 shadow-sm">
                  <img
                    src={item.url}
                    className="card-img-top"
                    alt="תמונה של נכס"
                    style={{ objectFit: "cover", height: "250px" }}
                  />
                  <div className="card-body text-end">
                    <h5 className="card-title">
                      סוג הנכס: {getTypeHomeLabel(item.type_house)}
                    </h5>
                    <p className="card-text">
                      רחוב {item.street} <br />
                      גודל: {item.count_meter} מ"ר <br />
                      {item.text_product}<br/>
                      לפרטים: 0529936265 shabatkotel@gmail.com
                    </p>
                  </div>
                </div>
              </div>
            ))
        )}
      </div>
    </div>
  );
};

export default Product;
